<template>
  <div class="col s12 m6">
     <iframe
      width="340"
      height="220"
      src="https://www.youtube.com/embed/GiyqGbBd0EY"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <br/>
    <br/>
      <br/>
    <br/>
     
   <h5><b>Some of Our Clients</b></h5>
   <br>
    
    <div id="owlClients" class="owl-carousel owl-theme">
      <div class="item">
        <img src="ui/img/client/teasy.jpg" alt="Biz 2" class="responsive-img" />
      </div>
      <div class="item">
        <img src="ui/img/client/uba.gif" alt="Biz 3" class="responsive-img" />
      </div>
      <div class="item">
        <img src="ui/img/client/union-bank.png" alt="Biz 4" class="responsive-img" />
      </div>
      <div class="item">
        <img src="ui/img/client/zenith.png" alt="Biz 5" class="responsive-img" />
      </div>
      <div class="item">
        <img src="ui/img/client/taj.png" alt="Biz 6" class="responsive-img" />
      </div>
      <div class="item">
        <img src="ui/img/client/micro1.png" alt="Biz 6" class="responsive-img" />
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'SolutionPart',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
#owlClients .owl-item img {
  width: 190px;
}
#owlTestimonial .owl-item img {
  width: 110px;
  border-radius: 50%;
  border: 5px solid #f05139;
  margin: auto;
}
</style>
